import React from 'react'

function AdminList() {
  return (
    <div>AdminList</div>
  )
}

export default AdminList